module.exports = __webpack_public_path__ + "img/logo-img.a73417a2.svg";